"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var umi_request_1 = require("umi-request");
var errorHandler = function (error) {
    var _a;
    (_a = console === null || console === void 0 ? void 0 : console.networkLogError) === null || _a === void 0 ? void 0 : _a.call(console, error);
    return error;
};
var request = (0, umi_request_1.extend)({
    credentials: "include",
    errorHandler: errorHandler,
});
request.interceptors.request.use(function (url, options) {
    var _a;
    (_a = console === null || console === void 0 ? void 0 : console.networkLogRequest) === null || _a === void 0 ? void 0 : _a.call(console, url, options);
    return {
        url: url,
        options: __assign({}, options),
    };
});
request.interceptors.response.use(function (response, options) {
    var _a;
    (_a = console === null || console === void 0 ? void 0 : console.networkLogResponse) === null || _a === void 0 ? void 0 : _a.call(console, response, options);
    return response;
});
exports.default = request;
